var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"variant":"primary","title":"Zapakuj","href":'#/Pakowanie/Zapakuj/' + _vm.recipeType + '/' + _vm.productId}},[_c('i',{staticClass:"fas fa-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }